/* tslint:disable */
/* eslint-disable */
/**
 * Data Sharing Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountLink
 */
export interface AccountLink {
    /**
     * Unique identifier for the account link
     * @type {string}
     * @memberof AccountLink
     */
    'id': string;
    /**
     * 
     * @type {AccountRegion}
     * @memberof AccountLink
     */
    'sharer_account_region'?: AccountRegion;
    /**
     * ID of the account (corresponds to Customer ID in Openfield)
     * @type {number}
     * @memberof AccountLink
     */
    'sharer_account_id'?: number;
    /**
     * The customer name for the sharer account
     * @type {string}
     * @memberof AccountLink
     */
    'sharer_account_name'?: string;
    /**
     * Optional name for the account link as seen by the sharer account
     * @type {string}
     * @memberof AccountLink
     */
    'sharer_link_name'?: string;
    /**
     * 
     * @type {AccountRegion}
     * @memberof AccountLink
     */
    'recipient_account_region': AccountRegion;
    /**
     * ID of the account (corresponds to Customer ID in Openfield)
     * @type {number}
     * @memberof AccountLink
     */
    'recipient_account_id': number;
    /**
     * The customer name for the recipient account
     * @type {string}
     * @memberof AccountLink
     */
    'recipient_account_name': string;
    /**
     * Name for the account link as seen by the recipient account
     * @type {string}
     * @memberof AccountLink
     */
    'recipient_link_name': string;
    /**
     * Unique code for the account link
     * @type {string}
     * @memberof AccountLink
     */
    'code': string;
    /**
     * Approval status of the account link
     * @type {boolean}
     * @memberof AccountLink
     */
    'is_approved': boolean;
    /**
     * Whether activity names are redacted.
     * @type {boolean}
     * @memberof AccountLink
     */
    'redact_activity_names': boolean;
    /**
     * Whether period names are redacted.
     * @type {boolean}
     * @memberof AccountLink
     */
    'redact_period_names': boolean;
    /**
     * Creation date and time of the account link.
     * @type {string}
     * @memberof AccountLink
     */
    'created_at': string;
    /**
     * Last update date and time of the account link
     * @type {string}
     * @memberof AccountLink
     */
    'modified_at': string;
}
/**
 * Region of the account
 * @export
 * @enum {string}
 */

export const AccountRegion = {
    Eu: 'EU',
    Us: 'US',
    Au: 'AU',
    Cn: 'CN'
} as const;

export type AccountRegion = typeof AccountRegion[keyof typeof AccountRegion];


/**
 * Represents a summary of an activity that is relevant for sharing based on a share agreement.
 * @export
 * @interface ActivitySummary
 */
export interface ActivitySummary {
    /**
     * Unique identifier for the activity
     * @type {string}
     * @memberof ActivitySummary
     */
    'id': string;
    /**
     * The name of the activity with any redaction applied
     * @type {string}
     * @memberof ActivitySummary
     */
    'name': string;
    /**
     * The start time of the activity
     * @type {string}
     * @memberof ActivitySummary
     */
    'start_time': string;
    /**
     * The number of periods in the activity
     * @type {number}
     * @memberof ActivitySummary
     */
    'period_count': number;
}
/**
 * 
 * @export
 * @interface ApproveShareAgreementItem
 */
export interface ApproveShareAgreementItem {
    /**
     * Unique identifier for the share agreement record
     * @type {string}
     * @memberof ApproveShareAgreementItem
     */
    'share_agreement_id': string;
    /**
     * Unique identifier for the athlete in the recipient account
     * @type {string}
     * @memberof ApproveShareAgreementItem
     */
    'recipient_athlete_id': string;
}
/**
 * 
 * @export
 * @interface BaseErrorResponse
 */
export interface BaseErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof BaseErrorResponse
     */
    'request_id': string;
    /**
     * 
     * @type {string}
     * @memberof BaseErrorResponse
     */
    'reason': string;
    /**
     * Optional list of field-specific errors
     * @type {Array<BaseErrorResponseFields>}
     * @memberof BaseErrorResponse
     */
    'fields'?: Array<BaseErrorResponseFields>;
}
/**
 * 
 * @export
 * @interface BaseErrorResponseFields
 */
export interface BaseErrorResponseFields {
    /**
     * The name of the field that caused the error
     * @type {string}
     * @memberof BaseErrorResponseFields
     */
    'field'?: string;
    /**
     * A description of the error related to the field
     * @type {string}
     * @memberof BaseErrorResponseFields
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface DeclineShareAgreementItem
 */
export interface DeclineShareAgreementItem {
    /**
     * Unique identifier for the share agreement record
     * @type {string}
     * @memberof DeclineShareAgreementItem
     */
    'share_agreement_id': string;
}
/**
 * 
 * @export
 * @interface GeneratedLinkingCode
 */
export interface GeneratedLinkingCode {
    /**
     * Unique identifier for the account link
     * @type {string}
     * @memberof GeneratedLinkingCode
     */
    'id': string;
    /**
     * 
     * @type {AccountRegion}
     * @memberof GeneratedLinkingCode
     */
    'recipient_account_region': AccountRegion;
    /**
     * ID of the account (corresponds to Customer ID in Openfield)
     * @type {number}
     * @memberof GeneratedLinkingCode
     */
    'recipient_account_id': number;
    /**
     * The customer name for the recipient account
     * @type {string}
     * @memberof GeneratedLinkingCode
     */
    'recipient_account_name': string;
    /**
     * Name for the account link as seen by the recipient account
     * @type {string}
     * @memberof GeneratedLinkingCode
     */
    'recipient_link_name': string;
    /**
     * Unique code for the account link
     * @type {string}
     * @memberof GeneratedLinkingCode
     */
    'code': string;
    /**
     * Creation date and time of the account link.
     * @type {string}
     * @memberof GeneratedLinkingCode
     */
    'created_at': string;
    /**
     * Last update date and time of the account link
     * @type {string}
     * @memberof GeneratedLinkingCode
     */
    'modified_at': string;
}
/**
 * 
 * @export
 * @interface RequestApproveAccountLink
 */
export interface RequestApproveAccountLink {
    /**
     * Unique code for the account link (format XXXX-XXXX-XXXX)
     * @type {string}
     * @memberof RequestApproveAccountLink
     */
    'code': string;
    /**
     * Optional name for the account link as seen by the sharer account
     * @type {string}
     * @memberof RequestApproveAccountLink
     */
    'sharer_link_name'?: string;
}
/**
 * 
 * @export
 * @interface RequestApproveShareAgreements
 */
export interface RequestApproveShareAgreements {
    /**
     * 
     * @type {Array<ApproveShareAgreementItem>}
     * @memberof RequestApproveShareAgreements
     */
    'approved': Array<ApproveShareAgreementItem>;
    /**
     * 
     * @type {Array<DeclineShareAgreementItem>}
     * @memberof RequestApproveShareAgreements
     */
    'declined'?: Array<DeclineShareAgreementItem>;
}
/**
 * 
 * @export
 * @interface RequestCancelShareAgreements
 */
export interface RequestCancelShareAgreements {
    /**
     * IDs of the share agreements to cancel.
     * @type {Array<string>}
     * @memberof RequestCancelShareAgreements
     */
    'share_agreement_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface RequestCreateShareAgreement
 */
export interface RequestCreateShareAgreement {
    /**
     * Start date of the sharing period
     * @type {string}
     * @memberof RequestCreateShareAgreement
     */
    'sharing_start_date': string;
    /**
     * End date of the sharing period
     * @type {string}
     * @memberof RequestCreateShareAgreement
     */
    'sharing_end_date': string;
    /**
     * Unique identifier for the athlete in the sharer account
     * @type {Array<string>}
     * @memberof RequestCreateShareAgreement
     */
    'sharer_athlete_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface RequestCreateShareJob
 */
export interface RequestCreateShareJob {
    /**
     * Optional override to only copy a subset of the activities/athlete data that fall within the sharing period. If not provided, all data within the sharing period will be copied. 
     * @type {string}
     * @memberof RequestCreateShareJob
     */
    'from_timestamp'?: string;
    /**
     * Optional override to only copy a subset of the activities/athlete data that fall within the sharing period. If not provided, all data within the sharing period will be copied. 
     * @type {string}
     * @memberof RequestCreateShareJob
     */
    'to_timestamp'?: string;
}
/**
 * 
 * @export
 * @interface RequestGenerateLinkingCode
 */
export interface RequestGenerateLinkingCode {
    /**
     * Label for the linking code (e.g. the name of the party to which they plan to send the code) 
     * @type {string}
     * @memberof RequestGenerateLinkingCode
     */
    'recipient_link_name': string;
}
/**
 * 
 * @export
 * @interface RequestStartShareJobs
 */
export interface RequestStartShareJobs {
    /**
     * List of share agreement IDs to start share jobs for.
     * @type {Array<string>}
     * @memberof RequestStartShareJobs
     */
    'share_agreement_ids': Array<string>;
}
/**
 * Fields that can be updated for an account link. At least one field must be provided.
 * @export
 * @interface RequestUpdateAccountLink
 */
export interface RequestUpdateAccountLink {
    /**
     * Optional name for the account link as seen by the sharer account. Can only be updated by sharer.
     * @type {string}
     * @memberof RequestUpdateAccountLink
     */
    'sharer_link_name'?: string;
    /**
     * Name for the account link as seen by the recipient account. Can only be updated by recipient.
     * @type {string}
     * @memberof RequestUpdateAccountLink
     */
    'recipient_link_name'?: string;
    /**
     * Whether activity names should be redacted. Can only be updated by sharer.
     * @type {boolean}
     * @memberof RequestUpdateAccountLink
     */
    'redact_activity_names'?: boolean;
    /**
     * Whether period names should be redacted. Can only be updated by sharer.
     * @type {boolean}
     * @memberof RequestUpdateAccountLink
     */
    'redact_period_names'?: boolean;
}
/**
 * 
 * @export
 * @interface RequestUpdateShareAgreement
 */
export interface RequestUpdateShareAgreement {
    /**
     * Start date of the sharing period. Can only be updated by sharer.
     * @type {string}
     * @memberof RequestUpdateShareAgreement
     */
    'sharing_start_date'?: string;
    /**
     * End date of the sharing period. Can only be updated by sharer.
     * @type {string}
     * @memberof RequestUpdateShareAgreement
     */
    'sharing_end_date'?: string;
    /**
     * Unique identifier for the athlete in the recipient account. Can only be updated by recipient.
     * @type {string}
     * @memberof RequestUpdateShareAgreement
     */
    'recipient_athlete_id'?: string;
    /**
     * Sets the status of the share agreement. Only \'cancelled\' is permitted. Can be updated by both sharer and recipient.
     * @type {string}
     * @memberof RequestUpdateShareAgreement
     */
    'status'?: RequestUpdateShareAgreementStatusEnum;
}

export const RequestUpdateShareAgreementStatusEnum = {
    Cancelled: 'cancelled'
} as const;

export type RequestUpdateShareAgreementStatusEnum = typeof RequestUpdateShareAgreementStatusEnum[keyof typeof RequestUpdateShareAgreementStatusEnum];

/**
 * 
 * @export
 * @interface RequestValidateLinkingCode
 */
export interface RequestValidateLinkingCode {
    /**
     * Unique code for the account link (format XXXX-XXXX-XXXX)
     * @type {string}
     * @memberof RequestValidateLinkingCode
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ShareAgreement
 */
export interface ShareAgreement {
    /**
     * Unique identifier for the share agreement record
     * @type {string}
     * @memberof ShareAgreement
     */
    'id': string;
    /**
     * Unique identifier for the associated account link
     * @type {string}
     * @memberof ShareAgreement
     */
    'account_link_id': string;
    /**
     * Unique identifier for the athlete in the recipient account
     * @type {string}
     * @memberof ShareAgreement
     */
    'recipient_athlete_id': string | null;
    /**
     * Unique identifier for the athlete in the sharer account
     * @type {string}
     * @memberof ShareAgreement
     */
    'sharer_athlete_id': string;
    /**
     * Name of the athlete referenced by the sharer athlete ID
     * @type {string}
     * @memberof ShareAgreement
     */
    'sharer_athlete_name': string;
    /**
     * Sharer\'s athlete velocity max
     * @type {number}
     * @memberof ShareAgreement
     */
    'sharer_velocity_max'?: number | null;
    /**
     * Sharer\'s athlete heart rate max
     * @type {number}
     * @memberof ShareAgreement
     */
    'sharer_heart_rate_max'?: number | null;
    /**
     * Start date of the sharing period
     * @type {string}
     * @memberof ShareAgreement
     */
    'sharing_start_date': string;
    /**
     * End date of the sharing period
     * @type {string}
     * @memberof ShareAgreement
     */
    'sharing_end_date': string;
    /**
     * 
     * @type {ShareAgreementStatus}
     * @memberof ShareAgreement
     */
    'status': ShareAgreementStatus;
    /**
     * Creation date and time of the share agreement
     * @type {string}
     * @memberof ShareAgreement
     */
    'created_at': string;
    /**
     * Last modification date and time of the share agreement
     * @type {string}
     * @memberof ShareAgreement
     */
    'modified_at': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ShareAgreementStatus = {
    Active: 'active',
    Cancelled: 'cancelled',
    Pending: 'pending',
    Expired: 'expired'
} as const;

export type ShareAgreementStatus = typeof ShareAgreementStatus[keyof typeof ShareAgreementStatus];


/**
 * 
 * @export
 * @interface ShareJob
 */
export interface ShareJob {
    /**
     * Unique identifier for the share job
     * @type {string}
     * @memberof ShareJob
     */
    'id': string;
    /**
     * Foreign key referencing the associated share agreement
     * @type {string}
     * @memberof ShareJob
     */
    'share_agreement_id': string;
    /**
     * Current status of the share job
     * @type {string}
     * @memberof ShareJob
     */
    'status': ShareJobStatusEnum;
    /**
     * Time the job was requested/created
     * @type {string}
     * @memberof ShareJob
     */
    'requested_at': string;
    /**
     * Time the job started execution
     * @type {string}
     * @memberof ShareJob
     */
    'started_at'?: string | null;
    /**
     * Time the job finished execution
     * @type {string}
     * @memberof ShareJob
     */
    'finished_at'?: string | null;
    /**
     * Lower bound for data collection (inclusive)
     * @type {string}
     * @memberof ShareJob
     */
    'from_timestamp': string;
    /**
     * Upper bound for data collection (inclusive)
     * @type {string}
     * @memberof ShareJob
     */
    'to_timestamp': string;
    /**
     * Human-readable summary for failures/partials (truncated)
     * @type {string}
     * @memberof ShareJob
     */
    'error_summary'?: string | null;
}

export const ShareJobStatusEnum = {
    Pending: 'pending',
    Running: 'running',
    Success: 'success',
    Failed: 'failed',
    Partial: 'partial'
} as const;

export type ShareJobStatusEnum = typeof ShareJobStatusEnum[keyof typeof ShareJobStatusEnum];

/**
 * 
 * @export
 * @interface ShareJobActivity
 */
export interface ShareJobActivity {
    /**
     * Unique identifier for the share job activity
     * @type {string}
     * @memberof ShareJobActivity
     */
    'id': string;
    /**
     * Foreign key referencing the associated share job
     * @type {string}
     * @memberof ShareJobActivity
     */
    'share_job_id': string;
    /**
     * Identifier for the activity
     * @type {string}
     * @memberof ShareJobActivity
     */
    'activity_id': string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof ShareJobActivity
     */
    'activity_name'?: string | null;
    /**
     * Timezone of the activity
     * @type {string}
     * @memberof ShareJobActivity
     */
    'activity_timezone'?: string | null;
    /**
     * Start time of the activity
     * @type {string}
     * @memberof ShareJobActivity
     */
    'activity_start_time'?: string | null;
    /**
     * Current status of the activity share operation. `skipped` is a terminal non-failure state: the source data could not be copied (e.g. live files were never synced to cloud) and the activity will not be re-attempted on subsequent imports. 
     * @type {string}
     * @memberof ShareJobActivity
     */
    'status': ShareJobActivityStatusEnum;
    /**
     * Number of attempts made to share this activity
     * @type {number}
     * @memberof ShareJobActivity
     */
    'attempt_count': number;
    /**
     * Last error message (truncated)
     * @type {string}
     * @memberof ShareJobActivity
     */
    'last_error'?: string | null;
    /**
     * Structured code for last_error. Null unless last_error is set.
     * @type {ShareJobActivityErrorCode}
     * @memberof ShareJobActivity
     */
    'error_code'?: ShareJobActivityErrorCode | null;
    /**
     * Creation date and time of the share job activity record
     * @type {string}
     * @memberof ShareJobActivity
     */
    'created_at': string;
    /**
     * Time when the activity share operation started
     * @type {string}
     * @memberof ShareJobActivity
     */
    'started_at'?: string | null;
    /**
     * Time when the activity share operation finished
     * @type {string}
     * @memberof ShareJobActivity
     */
    'finished_at'?: string | null;
}

export const ShareJobActivityStatusEnum = {
    Pending: 'pending',
    Running: 'running',
    Success: 'success',
    Failed: 'failed',
    Partial: 'partial',
    Skipped: 'skipped'
} as const;

export type ShareJobActivityStatusEnum = typeof ShareJobActivityStatusEnum[keyof typeof ShareJobActivityStatusEnum];

/**
 * Stable, machine-readable code identifying why a share job activity failed or was skipped. Set whenever last_error is set; null otherwise. Frontend should branch on this value (not last_error) to render localized messages. Codes:   * raw_file_activity_error - Raw data files are missing from the source account   * live_file_activity_error - Live (OFD) files are missing data at the source (e.g. pre-Vector 8 LPS); paired with status=skipped   * err_timeout - Network timeout during file transfer   * activity_exists - Activity already exists in the recipient account   * activity_not_found - Source activity could not be found   * no_pip - No athletes mapped to periods in the source data   * pip_overlap - An athlete is already in an overlapping period on the recipient side, so periods cannot be written   * unexpected_error - Generic / unclassified failure 
 * @export
 * @enum {string}
 */

export const ShareJobActivityErrorCode = {
    RawFileActivityError: 'raw_file_activity_error',
    LiveFileActivityError: 'live_file_activity_error',
    ErrTimeout: 'err_timeout',
    ActivityExists: 'activity_exists',
    ActivityNotFound: 'activity_not_found',
    NoPip: 'no_pip',
    PipOverlap: 'pip_overlap',
    UnexpectedError: 'unexpected_error'
} as const;

export type ShareJobActivityErrorCode = typeof ShareJobActivityErrorCode[keyof typeof ShareJobActivityErrorCode];


/**
 * 
 * @export
 * @interface SharerAthlete
 */
export interface SharerAthlete {
    /**
     * Unique identifier for the athlete
     * @type {string}
     * @memberof SharerAthlete
     */
    'id': string;
    /**
     * First name of the athlete
     * @type {string}
     * @memberof SharerAthlete
     */
    'first_name': string;
    /**
     * Last name of the athlete
     * @type {string}
     * @memberof SharerAthlete
     */
    'last_name': string;
    /**
     * Gender of the athlete
     * @type {string}
     * @memberof SharerAthlete
     */
    'gender'?: string;
    /**
     * Jersey number of the athlete
     * @type {string}
     * @memberof SharerAthlete
     */
    'jersey'?: string;
    /**
     * Nickname of the athlete
     * @type {string}
     * @memberof SharerAthlete
     */
    'nickname'?: string;
    /**
     * Height of the athlete in centimetres
     * @type {number}
     * @memberof SharerAthlete
     */
    'height'?: number;
    /**
     * Weight of the athlete in kilograms
     * @type {number}
     * @memberof SharerAthlete
     */
    'weight'?: number;
    /**
     * Date of birth as a Unix timestamp
     * @type {number}
     * @memberof SharerAthlete
     */
    'date_of_birth'?: number;
    /**
     * Date of birth in ISO 8601 date format
     * @type {string}
     * @memberof SharerAthlete
     */
    'date_of_birth_date'?: string;
    /**
     * Maximum velocity of the athlete
     * @type {number}
     * @memberof SharerAthlete
     */
    'velocity_max'?: number;
    /**
     * Maximum acceleration of the athlete
     * @type {number}
     * @memberof SharerAthlete
     */
    'acceleration_max'?: number;
    /**
     * Maximum heart rate of the athlete
     * @type {number}
     * @memberof SharerAthlete
     */
    'heart_rate_max'?: number;
    /**
     * Maximum player load of the athlete
     * @type {number}
     * @memberof SharerAthlete
     */
    'player_load_max'?: number;
    /**
     * Creation date and time of the athlete record
     * @type {string}
     * @memberof SharerAthlete
     */
    'created_at'?: string;
    /**
     * Last modification date and time of the athlete record
     * @type {string}
     * @memberof SharerAthlete
     */
    'modified_at'?: string;
}

/**
 * AccountLinksApi - axios parameter creator
 * @export
 */
export const AccountLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Approve and optionally name an account link using its ID
         * @summary Approve account link
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestApproveAccountLink} requestApproveAccountLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccountLink: async (accountLinkId: string, requestApproveAccountLink: RequestApproveAccountLink, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountLinkId' is not null or undefined
            assertParamExists('approveAccountLink', 'accountLinkId', accountLinkId)
            // verify required parameter 'requestApproveAccountLink' is not null or undefined
            assertParamExists('approveAccountLink', 'requestApproveAccountLink', requestApproveAccountLink)
            const localVarPath = `/account-links/{account_link_id}/approve`
                .replace(`{${"account_link_id"}}`, encodeURIComponent(String(accountLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestApproveAccountLink, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing account link.
         * @summary Delete account link (sharer or recipient)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountLink: async (accountLinkId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountLinkId' is not null or undefined
            assertParamExists('deleteAccountLink', 'accountLinkId', accountLinkId)
            const localVarPath = `/account-links/{account_link_id}`
                .replace(`{${"account_link_id"}}`, encodeURIComponent(String(accountLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a linking code that the recipient can send to the sharing party for them to approve the account link. 
         * @summary Generate a linking code (recipient)
         * @param {RequestGenerateLinkingCode} requestGenerateLinkingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLinkingCode: async (requestGenerateLinkingCode: RequestGenerateLinkingCode, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestGenerateLinkingCode' is not null or undefined
            assertParamExists('generateLinkingCode', 'requestGenerateLinkingCode', requestGenerateLinkingCode)
            const localVarPath = `/generate-linking-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestGenerateLinkingCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of account links where the authenticated account is either the sharer or recipient.
         * @summary Get account links (sharer or recipient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLinks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account-links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing account link. Which fields can be updated depends on whether the authenticated account is the sharer or recipient.
         * @summary Update account link (sharer or recipient)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestUpdateAccountLink} requestUpdateAccountLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountLink: async (accountLinkId: string, requestUpdateAccountLink: RequestUpdateAccountLink, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountLinkId' is not null or undefined
            assertParamExists('updateAccountLink', 'accountLinkId', accountLinkId)
            // verify required parameter 'requestUpdateAccountLink' is not null or undefined
            assertParamExists('updateAccountLink', 'requestUpdateAccountLink', requestUpdateAccountLink)
            const localVarPath = `/account-links/{account_link_id}`
                .replace(`{${"account_link_id"}}`, encodeURIComponent(String(accountLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestUpdateAccountLink, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates a linking code and returns the associated account link details if valid. 
         * @summary Validate a linking code
         * @param {RequestValidateLinkingCode} requestValidateLinkingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLinkingCode: async (requestValidateLinkingCode: RequestValidateLinkingCode, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestValidateLinkingCode' is not null or undefined
            assertParamExists('validateLinkingCode', 'requestValidateLinkingCode', requestValidateLinkingCode)
            const localVarPath = `/validate-linking-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestValidateLinkingCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountLinksApi - functional programming interface
 * @export
 */
export const AccountLinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountLinksApiAxiosParamCreator(configuration)
    return {
        /**
         * Approve and optionally name an account link using its ID
         * @summary Approve account link
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestApproveAccountLink} requestApproveAccountLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAccountLink(accountLinkId: string, requestApproveAccountLink: RequestApproveAccountLink, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAccountLink(accountLinkId, requestApproveAccountLink, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete an existing account link.
         * @summary Delete account link (sharer or recipient)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountLink(accountLinkId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountLink(accountLinkId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a linking code that the recipient can send to the sharing party for them to approve the account link. 
         * @summary Generate a linking code (recipient)
         * @param {RequestGenerateLinkingCode} requestGenerateLinkingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLinkingCode(requestGenerateLinkingCode: RequestGenerateLinkingCode, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratedLinkingCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLinkingCode(requestGenerateLinkingCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of account links where the authenticated account is either the sharer or recipient.
         * @summary Get account links (sharer or recipient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountLinks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountLinks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing account link. Which fields can be updated depends on whether the authenticated account is the sharer or recipient.
         * @summary Update account link (sharer or recipient)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestUpdateAccountLink} requestUpdateAccountLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountLink(accountLinkId: string, requestUpdateAccountLink: RequestUpdateAccountLink, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountLink(accountLinkId, requestUpdateAccountLink, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates a linking code and returns the associated account link details if valid. 
         * @summary Validate a linking code
         * @param {RequestValidateLinkingCode} requestValidateLinkingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateLinkingCode(requestValidateLinkingCode: RequestValidateLinkingCode, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateLinkingCode(requestValidateLinkingCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountLinksApi - factory interface
 * @export
 */
export const AccountLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountLinksApiFp(configuration)
    return {
        /**
         * Approve and optionally name an account link using its ID
         * @summary Approve account link
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestApproveAccountLink} requestApproveAccountLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccountLink(accountLinkId: string, requestApproveAccountLink: RequestApproveAccountLink, options?: any): AxiosPromise<AccountLink> {
            return localVarFp.approveAccountLink(accountLinkId, requestApproveAccountLink, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing account link.
         * @summary Delete account link (sharer or recipient)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountLink(accountLinkId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAccountLink(accountLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a linking code that the recipient can send to the sharing party for them to approve the account link. 
         * @summary Generate a linking code (recipient)
         * @param {RequestGenerateLinkingCode} requestGenerateLinkingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLinkingCode(requestGenerateLinkingCode: RequestGenerateLinkingCode, options?: any): AxiosPromise<GeneratedLinkingCode> {
            return localVarFp.generateLinkingCode(requestGenerateLinkingCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of account links where the authenticated account is either the sharer or recipient.
         * @summary Get account links (sharer or recipient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLinks(options?: any): AxiosPromise<Array<AccountLink>> {
            return localVarFp.getAccountLinks(options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing account link. Which fields can be updated depends on whether the authenticated account is the sharer or recipient.
         * @summary Update account link (sharer or recipient)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestUpdateAccountLink} requestUpdateAccountLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountLink(accountLinkId: string, requestUpdateAccountLink: RequestUpdateAccountLink, options?: any): AxiosPromise<AccountLink> {
            return localVarFp.updateAccountLink(accountLinkId, requestUpdateAccountLink, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates a linking code and returns the associated account link details if valid. 
         * @summary Validate a linking code
         * @param {RequestValidateLinkingCode} requestValidateLinkingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLinkingCode(requestValidateLinkingCode: RequestValidateLinkingCode, options?: any): AxiosPromise<AccountLink> {
            return localVarFp.validateLinkingCode(requestValidateLinkingCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountLinksApi - object-oriented interface
 * @export
 * @class AccountLinksApi
 * @extends {BaseAPI}
 */
export class AccountLinksApi extends BaseAPI {
    /**
     * Approve and optionally name an account link using its ID
     * @summary Approve account link
     * @param {string} accountLinkId Unique identifier for the account link
     * @param {RequestApproveAccountLink} requestApproveAccountLink 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountLinksApi
     */
    public approveAccountLink(accountLinkId: string, requestApproveAccountLink: RequestApproveAccountLink, options?: AxiosRequestConfig) {
        return AccountLinksApiFp(this.configuration).approveAccountLink(accountLinkId, requestApproveAccountLink, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing account link.
     * @summary Delete account link (sharer or recipient)
     * @param {string} accountLinkId Unique identifier for the account link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountLinksApi
     */
    public deleteAccountLink(accountLinkId: string, options?: AxiosRequestConfig) {
        return AccountLinksApiFp(this.configuration).deleteAccountLink(accountLinkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a linking code that the recipient can send to the sharing party for them to approve the account link. 
     * @summary Generate a linking code (recipient)
     * @param {RequestGenerateLinkingCode} requestGenerateLinkingCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountLinksApi
     */
    public generateLinkingCode(requestGenerateLinkingCode: RequestGenerateLinkingCode, options?: AxiosRequestConfig) {
        return AccountLinksApiFp(this.configuration).generateLinkingCode(requestGenerateLinkingCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of account links where the authenticated account is either the sharer or recipient.
     * @summary Get account links (sharer or recipient)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountLinksApi
     */
    public getAccountLinks(options?: AxiosRequestConfig) {
        return AccountLinksApiFp(this.configuration).getAccountLinks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing account link. Which fields can be updated depends on whether the authenticated account is the sharer or recipient.
     * @summary Update account link (sharer or recipient)
     * @param {string} accountLinkId Unique identifier for the account link
     * @param {RequestUpdateAccountLink} requestUpdateAccountLink 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountLinksApi
     */
    public updateAccountLink(accountLinkId: string, requestUpdateAccountLink: RequestUpdateAccountLink, options?: AxiosRequestConfig) {
        return AccountLinksApiFp(this.configuration).updateAccountLink(accountLinkId, requestUpdateAccountLink, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates a linking code and returns the associated account link details if valid. 
     * @summary Validate a linking code
     * @param {RequestValidateLinkingCode} requestValidateLinkingCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountLinksApi
     */
    public validateLinkingCode(requestValidateLinkingCode: RequestValidateLinkingCode, options?: AxiosRequestConfig) {
        return AccountLinksApiFp(this.configuration).validateLinkingCode(requestValidateLinkingCode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options?: any): AxiosPromise<string> {
            return localVarFp.healthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * Health check
     * @summary Health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthCheck(options?: AxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShareAgreementsApi - axios parameter creator
 * @export
 */
export const ShareAgreementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Approve or decline one or more share agreements. Approved agreements must include the recipient athlete ID to map the sharer\'s athlete to in the recipient account. Declined agreements will be deleted. 
         * @summary Approve or decline share agreements (recipient)
         * @param {RequestApproveShareAgreements} requestApproveShareAgreements 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveShareAgreements: async (requestApproveShareAgreements: RequestApproveShareAgreements, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestApproveShareAgreements' is not null or undefined
            assertParamExists('approveShareAgreements', 'requestApproveShareAgreements', requestApproveShareAgreements)
            const localVarPath = `/share-agreements/approvals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestApproveShareAgreements, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel one or more share agreements in a single transaction. Either side of the account link may cancel agreements they are a party to. Fires at most one ds_share_cancelled notification per call, suppressed when notify=false. 
         * @summary Bulk-cancel share agreements (sharer or recipient)
         * @param {RequestCancelShareAgreements} requestCancelShareAgreements 
         * @param {boolean} [notify] When false, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. Defaults to true. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelShareAgreements: async (requestCancelShareAgreements: RequestCancelShareAgreements, notify?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestCancelShareAgreements' is not null or undefined
            assertParamExists('cancelShareAgreements', 'requestCancelShareAgreements', requestCancelShareAgreements)
            const localVarPath = `/share-agreements/cancellations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (notify !== undefined) {
                localVarQueryParameter['notify'] = notify;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCancelShareAgreements, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create agreement to share athletes from the sharer account to the recipient account for the specified account link.
         * @summary Create share agreements for given athletes for an account link (sharer)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestCreateShareAgreement} requestCreateShareAgreement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareAgreements: async (accountLinkId: string, requestCreateShareAgreement: RequestCreateShareAgreement, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountLinkId' is not null or undefined
            assertParamExists('createShareAgreements', 'accountLinkId', accountLinkId)
            // verify required parameter 'requestCreateShareAgreement' is not null or undefined
            assertParamExists('createShareAgreements', 'requestCreateShareAgreement', requestCreateShareAgreement)
            const localVarPath = `/account-links/{account_link_id}/share-agreements`
                .replace(`{${"account_link_id"}}`, encodeURIComponent(String(accountLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCreateShareAgreement, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a share agreement record.
         * @summary Delete share agreement (sharer or recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShareAgreement: async (shareAgreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareAgreementId' is not null or undefined
            assertParamExists('deleteShareAgreement', 'shareAgreementId', shareAgreementId)
            const localVarPath = `/share-agreements/{share_agreement_id}`
                .replace(`{${"share_agreement_id"}}`, encodeURIComponent(String(shareAgreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of activity summaries for the given share agreement. 
         * @summary Get activity summaries for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {'new'} [status] Filter activities based on their sharing status for the given share agreement. Options: - new: Activities in the sharing period that were created or modified since the last successful   share job. If no successful share job exists, all activities in the sharing period are returned. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitySummaries: async (shareAgreementId: string, status?: 'new', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareAgreementId' is not null or undefined
            assertParamExists('getActivitySummaries', 'shareAgreementId', shareAgreementId)
            const localVarPath = `/share-agreements/{share_agreement_id}/activity-summaries`
                .replace(`{${"share_agreement_id"}}`, encodeURIComponent(String(shareAgreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of share agreements for the authenticated account.
         * @summary Get share agreements (sharer or recipient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareAgreements: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/share-agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the sharer athlete details for the given share agreement. This allows the recipient to view information about the athlete being shared, using the sharer athlete ID stored in the share agreement. 
         * @summary Get sharer athlete details for a share agreement (recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharerAthlete: async (shareAgreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareAgreementId' is not null or undefined
            assertParamExists('getSharerAthlete', 'shareAgreementId', shareAgreementId)
            const localVarPath = `/share-agreements/{share_agreement_id}/sharer-athlete`
                .replace(`{${"share_agreement_id"}}`, encodeURIComponent(String(shareAgreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a share agreement. Sharer can update only the sharing period. Recipient can update only the recipient athlete ID. Both sharer and recipient can update the status to cancelled. 
         * @summary Update share agreement (sharer or recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {boolean} [notify] When false and the update transitions status to cancelled, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. No-op for other update kinds. Defaults to true. 
         * @param {RequestUpdateShareAgreement} [requestUpdateShareAgreement] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShareAgreement: async (shareAgreementId: string, notify?: boolean, requestUpdateShareAgreement?: RequestUpdateShareAgreement, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareAgreementId' is not null or undefined
            assertParamExists('updateShareAgreement', 'shareAgreementId', shareAgreementId)
            const localVarPath = `/share-agreements/{share_agreement_id}`
                .replace(`{${"share_agreement_id"}}`, encodeURIComponent(String(shareAgreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (notify !== undefined) {
                localVarQueryParameter['notify'] = notify;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestUpdateShareAgreement, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShareAgreementsApi - functional programming interface
 * @export
 */
export const ShareAgreementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShareAgreementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Approve or decline one or more share agreements. Approved agreements must include the recipient athlete ID to map the sharer\'s athlete to in the recipient account. Declined agreements will be deleted. 
         * @summary Approve or decline share agreements (recipient)
         * @param {RequestApproveShareAgreements} requestApproveShareAgreements 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveShareAgreements(requestApproveShareAgreements: RequestApproveShareAgreements, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareAgreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveShareAgreements(requestApproveShareAgreements, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cancel one or more share agreements in a single transaction. Either side of the account link may cancel agreements they are a party to. Fires at most one ds_share_cancelled notification per call, suppressed when notify=false. 
         * @summary Bulk-cancel share agreements (sharer or recipient)
         * @param {RequestCancelShareAgreements} requestCancelShareAgreements 
         * @param {boolean} [notify] When false, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. Defaults to true. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelShareAgreements(requestCancelShareAgreements: RequestCancelShareAgreements, notify?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareAgreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelShareAgreements(requestCancelShareAgreements, notify, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create agreement to share athletes from the sharer account to the recipient account for the specified account link.
         * @summary Create share agreements for given athletes for an account link (sharer)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestCreateShareAgreement} requestCreateShareAgreement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShareAgreements(accountLinkId: string, requestCreateShareAgreement: RequestCreateShareAgreement, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareAgreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShareAgreements(accountLinkId, requestCreateShareAgreement, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a share agreement record.
         * @summary Delete share agreement (sharer or recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteShareAgreement(shareAgreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteShareAgreement(shareAgreementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of activity summaries for the given share agreement. 
         * @summary Get activity summaries for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {'new'} [status] Filter activities based on their sharing status for the given share agreement. Options: - new: Activities in the sharing period that were created or modified since the last successful   share job. If no successful share job exists, all activities in the sharing period are returned. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitySummaries(shareAgreementId: string, status?: 'new', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivitySummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitySummaries(shareAgreementId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of share agreements for the authenticated account.
         * @summary Get share agreements (sharer or recipient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareAgreements(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareAgreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareAgreements(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the sharer athlete details for the given share agreement. This allows the recipient to view information about the athlete being shared, using the sharer athlete ID stored in the share agreement. 
         * @summary Get sharer athlete details for a share agreement (recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharerAthlete(shareAgreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharerAthlete>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharerAthlete(shareAgreementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a share agreement. Sharer can update only the sharing period. Recipient can update only the recipient athlete ID. Both sharer and recipient can update the status to cancelled. 
         * @summary Update share agreement (sharer or recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {boolean} [notify] When false and the update transitions status to cancelled, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. No-op for other update kinds. Defaults to true. 
         * @param {RequestUpdateShareAgreement} [requestUpdateShareAgreement] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShareAgreement(shareAgreementId: string, notify?: boolean, requestUpdateShareAgreement?: RequestUpdateShareAgreement, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareAgreement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShareAgreement(shareAgreementId, notify, requestUpdateShareAgreement, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShareAgreementsApi - factory interface
 * @export
 */
export const ShareAgreementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShareAgreementsApiFp(configuration)
    return {
        /**
         * Approve or decline one or more share agreements. Approved agreements must include the recipient athlete ID to map the sharer\'s athlete to in the recipient account. Declined agreements will be deleted. 
         * @summary Approve or decline share agreements (recipient)
         * @param {RequestApproveShareAgreements} requestApproveShareAgreements 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveShareAgreements(requestApproveShareAgreements: RequestApproveShareAgreements, options?: any): AxiosPromise<Array<ShareAgreement>> {
            return localVarFp.approveShareAgreements(requestApproveShareAgreements, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel one or more share agreements in a single transaction. Either side of the account link may cancel agreements they are a party to. Fires at most one ds_share_cancelled notification per call, suppressed when notify=false. 
         * @summary Bulk-cancel share agreements (sharer or recipient)
         * @param {RequestCancelShareAgreements} requestCancelShareAgreements 
         * @param {boolean} [notify] When false, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. Defaults to true. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelShareAgreements(requestCancelShareAgreements: RequestCancelShareAgreements, notify?: boolean, options?: any): AxiosPromise<Array<ShareAgreement>> {
            return localVarFp.cancelShareAgreements(requestCancelShareAgreements, notify, options).then((request) => request(axios, basePath));
        },
        /**
         * Create agreement to share athletes from the sharer account to the recipient account for the specified account link.
         * @summary Create share agreements for given athletes for an account link (sharer)
         * @param {string} accountLinkId Unique identifier for the account link
         * @param {RequestCreateShareAgreement} requestCreateShareAgreement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareAgreements(accountLinkId: string, requestCreateShareAgreement: RequestCreateShareAgreement, options?: any): AxiosPromise<Array<ShareAgreement>> {
            return localVarFp.createShareAgreements(accountLinkId, requestCreateShareAgreement, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a share agreement record.
         * @summary Delete share agreement (sharer or recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShareAgreement(shareAgreementId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteShareAgreement(shareAgreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of activity summaries for the given share agreement. 
         * @summary Get activity summaries for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {'new'} [status] Filter activities based on their sharing status for the given share agreement. Options: - new: Activities in the sharing period that were created or modified since the last successful   share job. If no successful share job exists, all activities in the sharing period are returned. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitySummaries(shareAgreementId: string, status?: 'new', options?: any): AxiosPromise<Array<ActivitySummary>> {
            return localVarFp.getActivitySummaries(shareAgreementId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of share agreements for the authenticated account.
         * @summary Get share agreements (sharer or recipient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareAgreements(options?: any): AxiosPromise<Array<ShareAgreement>> {
            return localVarFp.getShareAgreements(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the sharer athlete details for the given share agreement. This allows the recipient to view information about the athlete being shared, using the sharer athlete ID stored in the share agreement. 
         * @summary Get sharer athlete details for a share agreement (recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharerAthlete(shareAgreementId: string, options?: any): AxiosPromise<SharerAthlete> {
            return localVarFp.getSharerAthlete(shareAgreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a share agreement. Sharer can update only the sharing period. Recipient can update only the recipient athlete ID. Both sharer and recipient can update the status to cancelled. 
         * @summary Update share agreement (sharer or recipient)
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {boolean} [notify] When false and the update transitions status to cancelled, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. No-op for other update kinds. Defaults to true. 
         * @param {RequestUpdateShareAgreement} [requestUpdateShareAgreement] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShareAgreement(shareAgreementId: string, notify?: boolean, requestUpdateShareAgreement?: RequestUpdateShareAgreement, options?: any): AxiosPromise<ShareAgreement> {
            return localVarFp.updateShareAgreement(shareAgreementId, notify, requestUpdateShareAgreement, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShareAgreementsApi - object-oriented interface
 * @export
 * @class ShareAgreementsApi
 * @extends {BaseAPI}
 */
export class ShareAgreementsApi extends BaseAPI {
    /**
     * Approve or decline one or more share agreements. Approved agreements must include the recipient athlete ID to map the sharer\'s athlete to in the recipient account. Declined agreements will be deleted. 
     * @summary Approve or decline share agreements (recipient)
     * @param {RequestApproveShareAgreements} requestApproveShareAgreements 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public approveShareAgreements(requestApproveShareAgreements: RequestApproveShareAgreements, options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).approveShareAgreements(requestApproveShareAgreements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel one or more share agreements in a single transaction. Either side of the account link may cancel agreements they are a party to. Fires at most one ds_share_cancelled notification per call, suppressed when notify=false. 
     * @summary Bulk-cancel share agreements (sharer or recipient)
     * @param {RequestCancelShareAgreements} requestCancelShareAgreements 
     * @param {boolean} [notify] When false, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. Defaults to true. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public cancelShareAgreements(requestCancelShareAgreements: RequestCancelShareAgreements, notify?: boolean, options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).cancelShareAgreements(requestCancelShareAgreements, notify, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create agreement to share athletes from the sharer account to the recipient account for the specified account link.
     * @summary Create share agreements for given athletes for an account link (sharer)
     * @param {string} accountLinkId Unique identifier for the account link
     * @param {RequestCreateShareAgreement} requestCreateShareAgreement 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public createShareAgreements(accountLinkId: string, requestCreateShareAgreement: RequestCreateShareAgreement, options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).createShareAgreements(accountLinkId, requestCreateShareAgreement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a share agreement record.
     * @summary Delete share agreement (sharer or recipient)
     * @param {string} shareAgreementId Unique identifier for the share agreement record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public deleteShareAgreement(shareAgreementId: string, options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).deleteShareAgreement(shareAgreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of activity summaries for the given share agreement. 
     * @summary Get activity summaries for a share agreement
     * @param {string} shareAgreementId Unique identifier for the share agreement record
     * @param {'new'} [status] Filter activities based on their sharing status for the given share agreement. Options: - new: Activities in the sharing period that were created or modified since the last successful   share job. If no successful share job exists, all activities in the sharing period are returned. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public getActivitySummaries(shareAgreementId: string, status?: 'new', options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).getActivitySummaries(shareAgreementId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of share agreements for the authenticated account.
     * @summary Get share agreements (sharer or recipient)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public getShareAgreements(options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).getShareAgreements(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the sharer athlete details for the given share agreement. This allows the recipient to view information about the athlete being shared, using the sharer athlete ID stored in the share agreement. 
     * @summary Get sharer athlete details for a share agreement (recipient)
     * @param {string} shareAgreementId Unique identifier for the share agreement record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public getSharerAthlete(shareAgreementId: string, options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).getSharerAthlete(shareAgreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a share agreement. Sharer can update only the sharing period. Recipient can update only the recipient athlete ID. Both sharer and recipient can update the status to cancelled. 
     * @summary Update share agreement (sharer or recipient)
     * @param {string} shareAgreementId Unique identifier for the share agreement record
     * @param {boolean} [notify] When false and the update transitions status to cancelled, suppresses the ds_share_cancelled notification that would otherwise fire to the counterparty. No-op for other update kinds. Defaults to true. 
     * @param {RequestUpdateShareAgreement} [requestUpdateShareAgreement] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareAgreementsApi
     */
    public updateShareAgreement(shareAgreementId: string, notify?: boolean, requestUpdateShareAgreement?: RequestUpdateShareAgreement, options?: AxiosRequestConfig) {
        return ShareAgreementsApiFp(this.configuration).updateShareAgreement(shareAgreementId, notify, requestUpdateShareAgreement, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShareJobsApi - axios parameter creator
 * @export
 */
export const ShareJobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the latest share job activity record for each unique activity that has been processed under the given share agreement. 
         * @summary Get latest activity status for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareAgreementActivityStatus: async (shareAgreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareAgreementId' is not null or undefined
            assertParamExists('getShareAgreementActivityStatus', 'shareAgreementId', shareAgreementId)
            const localVarPath = `/share-agreements/{share_agreement_id}/activity-status`
                .replace(`{${"share_agreement_id"}}`, encodeURIComponent(String(shareAgreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of share jobs that have been triggered for a given share agreement.
         * @summary Get share jobs for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareAgreementJobs: async (shareAgreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareAgreementId' is not null or undefined
            assertParamExists('getShareAgreementJobs', 'shareAgreementId', shareAgreementId)
            const localVarPath = `/share-agreements/{share_agreement_id}/share-jobs`
                .replace(`{${"share_agreement_id"}}`, encodeURIComponent(String(shareAgreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the per-activity status records for a given share job.
         * @summary List share job activity status records
         * @param {string} shareJobId Unique identifier for the share job record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareJobActivities: async (shareJobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareJobId' is not null or undefined
            assertParamExists('getShareJobActivities', 'shareJobId', shareJobId)
            const localVarPath = `/share-jobs/{share_job_id}/activities`
                .replace(`{${"share_job_id"}}`, encodeURIComponent(String(shareJobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve details for a specific share job.
         * @summary Get share job details
         * @param {string} shareJobId Unique identifier for the share job record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareJobDetails: async (shareJobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareJobId' is not null or undefined
            assertParamExists('getShareJobDetails', 'shareJobId', shareJobId)
            const localVarPath = `/share-jobs/{share_job_id}`
                .replace(`{${"share_job_id"}}`, encodeURIComponent(String(shareJobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the most recent share job for every active share agreement across all account links where the authenticated account is the recipient. 
         * @summary Get latest share jobs for recipient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareJobs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/share-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create and trigger share jobs for the given share agreement to copy the activities/athlete data for the sharer  athlete to the recipient athlete based on the sharing period in the agreement. 
         * @summary Trigger a data share for the given share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {RequestCreateShareJob} [requestCreateShareJob] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startShareAgreementJobs: async (shareAgreementId: string, requestCreateShareJob?: RequestCreateShareJob, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareAgreementId' is not null or undefined
            assertParamExists('startShareAgreementJobs', 'shareAgreementId', shareAgreementId)
            const localVarPath = `/share-agreements/{share_agreement_id}/share-jobs`
                .replace(`{${"share_agreement_id"}}`, encodeURIComponent(String(shareAgreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestCreateShareJob, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create and trigger share jobs for the given list of share agreements. Each agreement is processed independently against the same orchestrator entry-point used by the per-agreement endpoint. Share agreements whose sharing period is already fully synced (nothing new to copy) are silently skipped — they will not appear in the response. The request fails on the first hard error from any agreement; no further share jobs are created in that request. 
         * @summary Trigger data shares for multiple share agreements
         * @param {RequestStartShareJobs} requestStartShareJobs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startShareJobs: async (requestStartShareJobs: RequestStartShareJobs, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestStartShareJobs' is not null or undefined
            assertParamExists('startShareJobs', 'requestStartShareJobs', requestStartShareJobs)
            const localVarPath = `/share-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestStartShareJobs, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShareJobsApi - functional programming interface
 * @export
 */
export const ShareJobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShareJobsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the latest share job activity record for each unique activity that has been processed under the given share agreement. 
         * @summary Get latest activity status for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareAgreementActivityStatus(shareAgreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareJobActivity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareAgreementActivityStatus(shareAgreementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of share jobs that have been triggered for a given share agreement.
         * @summary Get share jobs for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareAgreementJobs(shareAgreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareJob>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareAgreementJobs(shareAgreementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the per-activity status records for a given share job.
         * @summary List share job activity status records
         * @param {string} shareJobId Unique identifier for the share job record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareJobActivities(shareJobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareJobActivity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareJobActivities(shareJobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve details for a specific share job.
         * @summary Get share job details
         * @param {string} shareJobId Unique identifier for the share job record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareJobDetails(shareJobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareJobDetails(shareJobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the most recent share job for every active share agreement across all account links where the authenticated account is the recipient. 
         * @summary Get latest share jobs for recipient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareJobs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareJob>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareJobs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create and trigger share jobs for the given share agreement to copy the activities/athlete data for the sharer  athlete to the recipient athlete based on the sharing period in the agreement. 
         * @summary Trigger a data share for the given share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {RequestCreateShareJob} [requestCreateShareJob] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startShareAgreementJobs(shareAgreementId: string, requestCreateShareJob?: RequestCreateShareJob, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareJob>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startShareAgreementJobs(shareAgreementId, requestCreateShareJob, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create and trigger share jobs for the given list of share agreements. Each agreement is processed independently against the same orchestrator entry-point used by the per-agreement endpoint. Share agreements whose sharing period is already fully synced (nothing new to copy) are silently skipped — they will not appear in the response. The request fails on the first hard error from any agreement; no further share jobs are created in that request. 
         * @summary Trigger data shares for multiple share agreements
         * @param {RequestStartShareJobs} requestStartShareJobs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startShareJobs(requestStartShareJobs: RequestStartShareJobs, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShareJob>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startShareJobs(requestStartShareJobs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShareJobsApi - factory interface
 * @export
 */
export const ShareJobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShareJobsApiFp(configuration)
    return {
        /**
         * Returns the latest share job activity record for each unique activity that has been processed under the given share agreement. 
         * @summary Get latest activity status for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareAgreementActivityStatus(shareAgreementId: string, options?: any): AxiosPromise<Array<ShareJobActivity>> {
            return localVarFp.getShareAgreementActivityStatus(shareAgreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of share jobs that have been triggered for a given share agreement.
         * @summary Get share jobs for a share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareAgreementJobs(shareAgreementId: string, options?: any): AxiosPromise<Array<ShareJob>> {
            return localVarFp.getShareAgreementJobs(shareAgreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the per-activity status records for a given share job.
         * @summary List share job activity status records
         * @param {string} shareJobId Unique identifier for the share job record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareJobActivities(shareJobId: string, options?: any): AxiosPromise<Array<ShareJobActivity>> {
            return localVarFp.getShareJobActivities(shareJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve details for a specific share job.
         * @summary Get share job details
         * @param {string} shareJobId Unique identifier for the share job record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareJobDetails(shareJobId: string, options?: any): AxiosPromise<ShareJob> {
            return localVarFp.getShareJobDetails(shareJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the most recent share job for every active share agreement across all account links where the authenticated account is the recipient. 
         * @summary Get latest share jobs for recipient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareJobs(options?: any): AxiosPromise<Array<ShareJob>> {
            return localVarFp.getShareJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * Create and trigger share jobs for the given share agreement to copy the activities/athlete data for the sharer  athlete to the recipient athlete based on the sharing period in the agreement. 
         * @summary Trigger a data share for the given share agreement
         * @param {string} shareAgreementId Unique identifier for the share agreement record
         * @param {RequestCreateShareJob} [requestCreateShareJob] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startShareAgreementJobs(shareAgreementId: string, requestCreateShareJob?: RequestCreateShareJob, options?: any): AxiosPromise<Array<ShareJob>> {
            return localVarFp.startShareAgreementJobs(shareAgreementId, requestCreateShareJob, options).then((request) => request(axios, basePath));
        },
        /**
         * Create and trigger share jobs for the given list of share agreements. Each agreement is processed independently against the same orchestrator entry-point used by the per-agreement endpoint. Share agreements whose sharing period is already fully synced (nothing new to copy) are silently skipped — they will not appear in the response. The request fails on the first hard error from any agreement; no further share jobs are created in that request. 
         * @summary Trigger data shares for multiple share agreements
         * @param {RequestStartShareJobs} requestStartShareJobs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startShareJobs(requestStartShareJobs: RequestStartShareJobs, options?: any): AxiosPromise<Array<ShareJob>> {
            return localVarFp.startShareJobs(requestStartShareJobs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShareJobsApi - object-oriented interface
 * @export
 * @class ShareJobsApi
 * @extends {BaseAPI}
 */
export class ShareJobsApi extends BaseAPI {
    /**
     * Returns the latest share job activity record for each unique activity that has been processed under the given share agreement. 
     * @summary Get latest activity status for a share agreement
     * @param {string} shareAgreementId Unique identifier for the share agreement record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareJobsApi
     */
    public getShareAgreementActivityStatus(shareAgreementId: string, options?: AxiosRequestConfig) {
        return ShareJobsApiFp(this.configuration).getShareAgreementActivityStatus(shareAgreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of share jobs that have been triggered for a given share agreement.
     * @summary Get share jobs for a share agreement
     * @param {string} shareAgreementId Unique identifier for the share agreement record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareJobsApi
     */
    public getShareAgreementJobs(shareAgreementId: string, options?: AxiosRequestConfig) {
        return ShareJobsApiFp(this.configuration).getShareAgreementJobs(shareAgreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the per-activity status records for a given share job.
     * @summary List share job activity status records
     * @param {string} shareJobId Unique identifier for the share job record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareJobsApi
     */
    public getShareJobActivities(shareJobId: string, options?: AxiosRequestConfig) {
        return ShareJobsApiFp(this.configuration).getShareJobActivities(shareJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve details for a specific share job.
     * @summary Get share job details
     * @param {string} shareJobId Unique identifier for the share job record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareJobsApi
     */
    public getShareJobDetails(shareJobId: string, options?: AxiosRequestConfig) {
        return ShareJobsApiFp(this.configuration).getShareJobDetails(shareJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the most recent share job for every active share agreement across all account links where the authenticated account is the recipient. 
     * @summary Get latest share jobs for recipient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareJobsApi
     */
    public getShareJobs(options?: AxiosRequestConfig) {
        return ShareJobsApiFp(this.configuration).getShareJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create and trigger share jobs for the given share agreement to copy the activities/athlete data for the sharer  athlete to the recipient athlete based on the sharing period in the agreement. 
     * @summary Trigger a data share for the given share agreement
     * @param {string} shareAgreementId Unique identifier for the share agreement record
     * @param {RequestCreateShareJob} [requestCreateShareJob] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareJobsApi
     */
    public startShareAgreementJobs(shareAgreementId: string, requestCreateShareJob?: RequestCreateShareJob, options?: AxiosRequestConfig) {
        return ShareJobsApiFp(this.configuration).startShareAgreementJobs(shareAgreementId, requestCreateShareJob, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create and trigger share jobs for the given list of share agreements. Each agreement is processed independently against the same orchestrator entry-point used by the per-agreement endpoint. Share agreements whose sharing period is already fully synced (nothing new to copy) are silently skipped — they will not appear in the response. The request fails on the first hard error from any agreement; no further share jobs are created in that request. 
     * @summary Trigger data shares for multiple share agreements
     * @param {RequestStartShareJobs} requestStartShareJobs 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareJobsApi
     */
    public startShareJobs(requestStartShareJobs: RequestStartShareJobs, options?: AxiosRequestConfig) {
        return ShareJobsApiFp(this.configuration).startShareJobs(requestStartShareJobs, options).then((request) => request(this.axios, this.basePath));
    }
}


